import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { Selectors } from 'store/root-reducer';
import { DocumentsService } from 'modules/core/services/documents.service';
import { SnackbarService } from 'app/services/snackbar.service';
import { MAX_UPLOAD_SIZE } from 'modules/shared/constants/upload.constants';
var DocumentUpdateComponent = /** @class */ (function () {
    function DocumentUpdateComponent(fb, documentService, snackBar, sanitizer, cdRef, store, datePipe) {
        this.fb = fb;
        this.documentService = documentService;
        this.snackBar = snackBar;
        this.sanitizer = sanitizer;
        this.cdRef = cdRef;
        this.store = store;
        this.datePipe = datePipe;
        this.documentTypes = [];
        this.authenticities = [];
        this.updatedDocumentOutput = new EventEmitter();
        this.allowedFileType = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
        this.unsubscribe$ = new Subject();
        this.uploading = false;
        this.updatedDocument = {};
        this.maxIssueDate = new Date();
        this.documentThumbnail = [];
        this.buildDocumentForm();
    }
    Object.defineProperty(DocumentUpdateComponent.prototype, "uploadedDocument", {
        set: function (document) {
            if (!document) {
                return;
            }
            if (document.document && document.backDocument) {
                this.displayDocument = {
                    isFrontPdfFile: document.document.includes('.pdf'),
                    isBackPdfFile: document.backDocument.includes('.pdf'),
                    thumbnail: this.sanitizer.bypassSecurityTrustResourceUrl(document.document),
                    backThumbnail: this.sanitizer.bypassSecurityTrustResourceUrl(document.backDocument),
                };
            }
            else if (document.document) {
                this.displayDocument = {
                    isFrontPdfFile: document.document.includes('.pdf'),
                    isBackPdfFile: false,
                    thumbnail: this.sanitizer.bypassSecurityTrustResourceUrl(document.document),
                    backThumbnail: null,
                };
            }
            else if (document.backDocument) {
                this.displayDocument = {
                    isFrontPdfFile: null,
                    isBackPdfFile: document.backDocument.includes('.pdf'),
                    thumbnail: null,
                    backThumbnail: this.sanitizer.bypassSecurityTrustResourceUrl(document.backDocument),
                };
            }
            else {
                this.displayDocument = {
                    isFrontPdfFile: false,
                    isBackPdfFile: false,
                    thumbnail: null,
                    backThumbnail: null,
                };
            }
            this.updatedDocument = tslib_1.__assign({}, document);
            if (this.documentInfoForm) {
                this.documentInfoForm.reset();
                this.documentInfoForm.markAsPristine();
            }
            this.documentInfoForm.patchValue(this.updatedDocument);
            this.checkOtherDocumentTypeValue();
            this.cdRef.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    DocumentUpdateComponent.prototype.ngOnInit = function () {
        this.getBillableInfo();
    };
    DocumentUpdateComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * Builds form for the document
     * @method buildDocumentForm
     */
    DocumentUpdateComponent.prototype.buildDocumentForm = function () {
        var _this = this;
        this.documentInfoForm = this.fb.group({
            docType: [this.updatedDocument.docType || '', Validators.required],
            docTypeCategory: [this.updatedDocument.docTypeCategory || ''],
            otherDocType: [''],
            authenticity: [this.updatedDocument.authenticity || ''],
            docName: [{ value: this.updatedDocument.docName || '', disabled: true }, Validators.required],
            expiryDate: [this.updatedDocument.expiryDate || ''],
            issueDate: [this.updatedDocument.issueDate || ''],
            showExpiryAlerts: [true, this.updatedDocument.showExpiryAlerts || false],
            document: [this.updatedDocument.document],
            documentNumber: [this.updatedDocument.documentNumber || ''],
            backDocument: [this.updatedDocument.backDocument],
            backDocName: [{ value: this.updatedDocument.backDocName || '', disabled: true }, Validators.required],
        });
        if (this.documentInfoForm.get('docName')) {
            this.documentInfoForm
                .get('docName')
                .valueChanges
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(function (value) {
                if (value) {
                    var index = _this.documentThumbnail.findIndex(function (e) { return e.type === 'docName'; });
                    if (index > -1) {
                        _this.documentThumbnail.splice(index, 1, {
                            type: 'docName',
                            value: value,
                        });
                    }
                    else {
                        _this.documentThumbnail.splice(0, 0, {
                            type: 'docName',
                            value: value,
                        });
                    }
                }
            });
        }
        if (this.documentInfoForm.get('backDocName')) {
            this.documentInfoForm
                .get('backDocName')
                .valueChanges
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(function (value) {
                if (value) {
                    var index = _this.documentThumbnail.findIndex(function (e) { return e.type === 'backDocName'; });
                    if (index > -1) {
                        _this.documentThumbnail.splice(index, 1, {
                            type: 'backDocName',
                            value: value,
                        });
                    }
                    else {
                        _this.documentThumbnail.splice(0, 0, {
                            type: 'backDocName',
                            value: value,
                        });
                    }
                }
            });
        }
        if (this.isOtherDocType) {
            this.documentInfoForm.get('otherDocType').setValidators(Validators.required);
        }
        else {
            this.documentInfoForm.get('otherDocType').clearValidators();
        }
        this.documentInfoForm.get('otherDocType').updateValueAndValidity();
        this.documentInfoForm.get('issueDate').valueChanges.subscribe(function (issueDate) {
            if (issueDate) {
                _this.minExpiryDate = new Date(new Date(issueDate).getTime() + 1000 * 60 * 60 * 24);
            }
        });
        this.checkOtherDocumentTypeValue();
    };
    /**
     * @method checkOtherDocumentTypeValue
     * Check if the document type value is customized and set accordingly
     */
    DocumentUpdateComponent.prototype.checkOtherDocumentTypeValue = function () {
        var allDocumentTypeValues = [];
        if (this.documentTypes) {
            this.documentTypes.forEach(function (documentTypeCategory) {
                allDocumentTypeValues = allDocumentTypeValues.concat(documentTypeCategory.documentTypes);
            });
        }
        var isOtherDocumentType = this.updatedDocument.docType &&
            (this.updatedDocument.docType.toLowerCase() === 'others (pls specify)' ||
                !~allDocumentTypeValues.indexOf(this.updatedDocument.docType));
        if (isOtherDocumentType) {
            this.isOtherDocType = true;
            if (this.updatedDocument.docTypeCategory && this.updatedDocument.docTypeCategory.toLowerCase() !== 'others (pls specify)') {
                this.documentInfoForm.patchValue({
                    'docType': "OTHER " + this.updatedDocument.docTypeCategory,
                    'otherDocType': this.updatedDocument.docType
                });
            }
            else {
                this.documentInfoForm.patchValue({
                    'docType': "OTHERS (PLS SPECIFY)",
                    'otherDocType': this.updatedDocument.docType
                });
            }
        }
        else {
            this.isOtherDocType = false;
        }
    };
    /**
     * Get subscription information from state to decide whether FC and OCR are enabled
     * @method getBillableInfo
     */
    DocumentUpdateComponent.prototype.getBillableInfo = function () {
        var _this = this;
        combineLatest([
            this.store.select(Selectors.billable.getOCR),
            this.store.select(Selectors.billable.getFC)
        ])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (_a) {
            var ocrEnabled = _a[0], fcEnabled = _a[1];
            if (ocrEnabled && fcEnabled && (ocrEnabled.display || fcEnabled.display)) {
                _this.fcOrOcrEnabled = true;
                _this.documentInfoForm.get('document').setValidators([Validators.required]);
                _this.documentInfoForm.get('document').updateValueAndValidity();
            }
        });
    };
    /**
     * Builds form for the document
     * @method updateDocument
     */
    DocumentUpdateComponent.prototype.updateDocument = function () {
        var _this = this;
        if (this.documentInfoForm.valid) {
            this.uploading = true;
            if (this.isOtherDocType) {
                this.documentInfoForm.get('docType').setValue(this.documentInfoForm.get('otherDocType').value);
            }
            Object.assign(this.updatedDocument, tslib_1.__assign({}, this.documentInfoForm.value, { issueDate: this.datePipe.transform(this.documentInfoForm.get('issueDate').value, 'yyyy-MM-dd'), expiryDate: this.datePipe.transform(this.documentInfoForm.get('expiryDate').value, 'yyyy-MM-dd') }));
            if (typeof this.updatedDocument.document === 'string') {
                delete this.updatedDocument.document;
            }
            if (typeof this.updatedDocument.backDocument === 'string') {
                delete this.updatedDocument.backDocument;
            }
            if (this.updatedDocument.id) {
                this.documentService.updateRecordDocument(this.updatedDocument).subscribe(function (document) {
                    _this.updatedDocumentOutput.next({ document: document, mode: 'UPDATE' });
                    _this.uploading = false;
                }, function (error) {
                    if (error.error.detail === 'File has invalid content-type. Maybe file extension is not equal to file content?') {
                        _this.uploading = false;
                        _this.updatedDocumentOutput.next({ document: null, mode: 'CREATE', error: error.error.detail });
                    }
                    else {
                        _this.uploading = false;
                        _this.updatedDocumentOutput.next({ document: null, mode: 'CREATE', error: error.message });
                    }
                });
            }
            else {
                this.documentService.createRecordDocument(this.updatedDocument).subscribe(function (document) {
                    _this.uploading = false;
                    _this.updatedDocumentOutput.next({ document: document, mode: 'CREATE' });
                }, function (error) {
                    if (error.error.detail === 'File has invalid content-type. Maybe file extension is not equal to file content?') {
                        _this.uploading = false;
                        _this.updatedDocumentOutput.next({ document: null, mode: 'CREATE', error: error.error.detail });
                    }
                    else {
                        _this.uploading = false;
                        _this.updatedDocumentOutput.next({ document: null, mode: 'CREATE', error: error.message });
                    }
                });
            }
        }
    };
    /**
     * Handler when front of document is uploaded
     * @method frontDocumentUploadedHandler
     */
    DocumentUpdateComponent.prototype.frontDocumentUploadedHandler = function (files) {
        var _this = this;
        if (!files || files.length === 0) {
            return;
        }
        if (files[0].size > 10 * MAX_UPLOAD_SIZE) {
            this.snackBar.error("File size exceeds maximum limit 10 MB.");
            return;
        }
        if (!this.allowedFileType.includes(files[0].type)) {
            this.snackBar.error("Only png, jpg, jpeg or pdf is allowed.");
            return;
        }
        if (files[0].name.includes('.pdf')) {
            this.displayDocument.isFrontPdfFile = true;
        }
        else {
            this.displayDocument.isFrontPdfFile = false;
        }
        var fileReader = new FileReader();
        this.documentInfoForm.get('docName').setValue(files[0].name);
        this.documentInfoForm.get('document').setValue(files[0]);
        this.updatedDocument.frontDocumentFile = files[0];
        if (this.displayDocument.thumbnail) {
            this.displayDocument.thumbnail = null;
        }
        this.documentInfoForm.markAsDirty();
        this.cdRef.detectChanges();
        fileReader.onload = function (event) {
            _this.displayDocument.thumbnail = _this.sanitizer.bypassSecurityTrustResourceUrl(event.target.result);
            _this.cdRef.detectChanges();
        };
        fileReader.readAsDataURL(files[0]);
    };
    /**
       * Handler when back of document is uploaded
       * @method documentUploadedHandler
       */
    DocumentUpdateComponent.prototype.backDocumentUploadedHandler = function (files) {
        var _this = this;
        if (!files || files.length === 0) {
            return;
        }
        if (files[0].size > 10 * MAX_UPLOAD_SIZE) {
            this.snackBar.error("File size exceeds maximum limit 10 MB.");
            return;
        }
        if (!this.allowedFileType.includes(files[0].type)) {
            this.snackBar.error("Only png, jpg, jpeg or pdf is allowed.");
            return;
        }
        if (files[0].name.includes('.pdf')) {
            this.displayDocument.isBackPdfFile = true;
        }
        else {
            this.displayDocument.isBackPdfFile = false;
        }
        var fileReader = new FileReader();
        this.documentInfoForm.get('backDocName').setValue(files[0].name);
        this.documentInfoForm.get('backDocument').setValue(files[0]);
        this.updatedDocument.backDocumentFile = files[0];
        if (this.displayDocument.backThumbnail) {
            this.displayDocument.backThumbnail = null;
        }
        this.documentInfoForm.markAsDirty();
        this.cdRef.detectChanges();
        fileReader.onload = function (event) {
            _this.displayDocument.backThumbnail = _this.sanitizer.bypassSecurityTrustResourceUrl(event.target.result);
            _this.cdRef.detectChanges();
        };
        fileReader.readAsDataURL(files[0]);
    };
    DocumentUpdateComponent.prototype.removeBackDocument = function () {
        this.documentInfoForm.get('backDocName').reset();
        this.documentInfoForm.get('backDocName').updateValueAndValidity();
        this.documentInfoForm.get('backDocument').reset();
        this.documentInfoForm.get('backDocument').updateValueAndValidity();
        this.displayDocument.backThumbnail = null;
        this.updatedDocument.backDocumentFile = null;
        this.updatedDocument.backDocName = null;
        this.documentInfoForm.markAsDirty();
    };
    /**
     * Handler when document is uploaded
     * @method getThumbnail
     */
    DocumentUpdateComponent.prototype.getThumbnail = function () {
        return this.displayDocument.thumbnail || this.updatedDocument.document;
    };
    /**
     * Handler when back document is uploaded
     * @method getBackThumbnail
     */
    DocumentUpdateComponent.prototype.getBackThumbnail = function () {
        return this.displayDocument.backThumbnail || this.updatedDocument.backDocument;
    };
    /**
     * @method setSelectedDocumentType
     * Set selected document type value
     */
    DocumentUpdateComponent.prototype.setSelectedDocumentType = function (documentTypeCategory, documentType) {
        this.documentInfoForm.get('docTypeCategory').setValue(documentTypeCategory);
        this.isOtherDocType = documentType.toLowerCase() === 'others (pls specify)';
        if (documentType.toLowerCase() === 'others (pls specify)' && documentTypeCategory.toLowerCase() !== 'others (pls specify)') {
            this.documentInfoForm.get('docType').setValue("OTHER " + documentTypeCategory);
        }
        else {
            this.documentInfoForm.get('docType').setValue(documentType);
        }
        this.documentInfoForm.markAsDirty();
    };
    return DocumentUpdateComponent;
}());
export { DocumentUpdateComponent };
